import { render, staticRenderFns } from "./process-modal.vue?vue&type=template&id=2f59b54e&"
import script from "./process-modal.vue?vue&type=script&lang=js&"
export * from "./process-modal.vue?vue&type=script&lang=js&"
import style0 from "./process-modal.vue?vue&type=style&index=0&id=2f59b54e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports